import React, { useState } from 'react';
import { VStack } from 'native-base';
import { Caption } from '~/shared/Typography';
import Barcode from 'react-barcode';
import Pressable from '~/shared/Pressable';
import { Button } from '~/shared/Theme';

const BarcodeHolder = ({
    cardNumber,
    cardPin
}: {
    cardNumber: string,
    cardPin: string
}) => {

    const [showBarcode, setShowBarcode] =
        useState(false);

    return (
        <VStack space={4}>
            { !showBarcode &&
                <Button
                    alignSelf={'center'}
                    variant={'neutral'}
                    fontSize={22}
                    text={'giftCard.barcode.view'}
                    onPress={() => setShowBarcode(prev => !prev)}
                />
            }
            <Pressable
                onPress={() => setShowBarcode(prev => !prev)}
                alignItems={'center'}
            >
                { showBarcode &&
                    <Barcode
                        value={cardNumber}
                        format={'CODE128'}
                        background={'white'}
                    />
                }
                { !showBarcode &&
                    <Caption
                        textAlign={'center'}
                        fontSize={16}
                    >
                        { cardNumber }
                    </Caption>
                }
            </Pressable>
            <Caption
                textAlign={'center'}
                fontSize={16}
                text={'giftCard.pinCode'}
                textValues={[cardPin]}
            />
        </VStack>
    );
};

export default BarcodeHolder;
